function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.433,
    height: 23.6,
    viewBox: "0 0 33.433 23.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m32.706 3.8055c-0.3835-1.4406-1.2242-2.6599-2.6648-3.0434-2.6108-0.69817-13.324-0.76208-13.324-0.76208s-10.713 0.06392-13.324 0.76208c-1.4406 0.3835-2.2764 1.6028-2.6648 3.0434-0.69817 2.6108-0.72767 7.9945-0.72767 7.9945s0.0295 5.3838 0.72767 7.9945c0.3835 1.4406 1.2243 2.6599 2.6648 3.0434 2.6108 0.69817 13.324 0.76208 13.324 0.76208s10.713-0.06392 13.324-0.76208c1.4406-0.3835 2.2813-1.6028 2.6648-3.0434 0.69817-2.6108 0.72767-7.9945 0.72767-7.9945s-0.0295-5.3838-0.72767-7.9945z",
    style: {
      fillOpacity: 0.8,
      fill: "#f00a0d",
      strokeWidth: 0.49167
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.125 11.8-8.85-4.9167v9.8333",
    style: {
      fill: "#fff",
      strokeWidth: 0.49167
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.460ca599164ebdcc56048a1ba9d2a27f.svg";
export { ForwardRef as ReactComponent };